<template>
    <div class="privacy-paragraphs">
        <template v-for="(p, i) in term.paragraphs">
            <div :key="i" style="margin-bottom: 2px">
                <div class="paragraph-title" v-html="p.title"></div>
                <privacy-scroller style="margin-bottom:10px"
                    :paragraph="p"
                />
            </div>
        </template>
    </div>
</template>

<script>
import PrivacyScroller from './PrivacyScroller'
import {mapState} from 'puex'

export default {
  name: 'PrivacyParagraphs',
  components: {
    PrivacyScroller
  },
  computed: {
    ...mapState(['term', 'scrollTillTheEnd'])
  },
  props: ['paragraph']
}
</script>

<style lang="scss">
    $warning-height : 20px;
    .privacy-paragraphs{
        .paragraph-title {
            font-size:11px;
            text-align: left;
            padding: 4px;
            font-family: arial;
            font-weight: bold;
        }
        .scroll-warning{
            padding:0px 0 0 22px;
            margin-bottom: 0px;
            text-align: left;
            font-weight: normal;
            color: black;
            font-family: arial;
            font-size: 11px;
            // border: 1px solid #e1e1e1;
            // background-color:#fcecec;
            border-radius: 2px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/PrivacyParagraphs.vue